export const environment = {
  env: 'development',
  production: false,
  googleAnalyticsId: 'G-S5Y8Y17N6Y',
  restaurant: {
    name: '',
    logo: '',
    favicon: ''
  },
  happyApi: {
    baseUrl: 'https://happymanagement.yourmealprep.com/api/v1/tenant',
    tenant: 'abdultester',
    useGuestSession: true,
    stores: [
      {
        domain: 'abdulstoreupdated',
        name: 'tester',
        storeApiKey: 'sk_GFm9lsNn9qVHFELFGkG7hLURAdezyxKQ',
        address: {
          address_1: '',
          address_2: '',
          city: '',
          state: '',
          postcode: '',
          country: ''
        }
      }
    ]
  },
  addressy: {
    apiKey: 'WN85-CY69-AG78-ND97',
    apiUrl: 'https://api.addressy.com/Capture/Interactive'
  },
  colors: {
    primary: '#80ced7',
    secondary: '#2e2b4b',
    amountSelectorBg: '#2d3c48',
    amountSelectorText: '#ffffff',
    iconColor: '#292556'
  },
  buttonStyles: {
    primary: {
      color: '#ffffff',
      bg: '#303030',
      hover: '#6ab3bc'
    },
    secondary: {
      color: '#ffffff',
      bg: '#000000',
      hover: '#dadada'
    },
    contrast: {
      color: '#ffffff',
      bg: '#000000',
      hover: '#333333'
    },
    transparent: {
      color: '#000000',
      bg: 'transparent',
      hover: '#f5f5f5'
    },
    danger: {
      color: '#ffffff',
      bg: '#dc2626',
      hover: '#b91c1c'
    }
  },
  buttonSizes: {
    small:  { borderRadius: '8px' },
    medium: { borderRadius: '32px' },
    big:    { borderRadius: '20px' },
    large:  { borderRadius: '20px' },
    icon:   { borderRadius: '50%' }
  },
  clover: {
    publicKey: '238a7b545f36008777bf86a7fb6367b0',
    merchantId: 'TFX1FB6C2GNA1',
    isSandbox: true
  },
  stripe: {
    publishableKey: 'pk_test_51RwQpIARygk69W79EDQfMNP9gNh9KHMc70HQfZJL3ecWrdHdqDVoAKtvWwIdQGJhxfo973RF9WUuZieLwYik3OcC00ZnG7QxR6'
  },
  applePay: {
    merchantId: 'merchant.com.happyordering.pay',
    merchantName: 'Happy Ordering',
    supportedNetworks: ['visa', 'masterCard', 'amex', 'discover'],
    merchantCapabilities: ['supports3DS'],
    enabled: true
  },
  fontFamily: 'Satoshi'
};
